import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getCancelSubscriptionStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.CANCEL_SUBSCRIPTION);

export default getCancelSubscriptionStatus;
